import { CAROUSEL_IMAGE_WIDTH, POPOVER_WIDTH, SIDEBAR_WIDTH, SIDEPANEL_WIDTH } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
export function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
export function getImagePreviewProps(previewType) {
  let imagePreviewMaxWidth = 0;
  let zoomerWidth = 0;
  const iframeWidth = 900;
  if (previewType === 'popover') {
    imagePreviewMaxWidth = POPOVER_WIDTH;
    zoomerWidth = POPOVER_WIDTH - (20 + 1) * 2; // popover left/right padding + border
  } else if (previewType === 'sidepanel') {
    imagePreviewMaxWidth = SIDEPANEL_WIDTH;
    zoomerWidth = SIDEPANEL_WIDTH - (20 + 1) * 2; // sidepanel left/right padding + border
  } else if (previewType === 'carousel') {
    imagePreviewMaxWidth = CAROUSEL_IMAGE_WIDTH;
    zoomerWidth = CAROUSEL_IMAGE_WIDTH;
  } else {
    imagePreviewMaxWidth = SIDEBAR_WIDTH;
    zoomerWidth = SIDEBAR_WIDTH - (20 + 1) * 2; // sidebar left/right padding + border
  }
  const zoomerHeight = zoomerWidth * 3 / 4;
  const iframeScale = (zoomerWidth / iframeWidth).toFixed(3);
  return {
    iframeScale,
    iframeWidth,
    imagePreviewMaxWidth,
    zoomerHeight,
    zoomerWidth
  };
}
export function lowerCase(value) {
  const re = /^[A-Z]{2,}/;
  if (re.test(value)) {
    return value;
  }
  return value.toLowerCase();
}